// Reusable functions to bind events
const cartDrawer = document.getElementById("cartDrawer");
const overlay = document.getElementById("cartDrawerOverlay");
const cartIcon = document.querySelector(".js-drawer-open-cart");
const cartDrawerClose = document.querySelector(".cart-drawer-close-btn");

let cartNoteSaveTimer;
let cartNoteLastSavedValue = null;
let cartNoteRequest = null;

function bindQuantityControls() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input");
      const increaseBtn = container.querySelector('[data-action="increase"]');
      const decreaseBtn = container.querySelector('[data-action="decrease"]');
      const removeBtn = container.querySelector(".remove-btn");

      const spinner = document.createElement("div");
      spinner.className = "spinner";
      spinner.innerHTML = `
        <svg class="spinner-icon" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
        </svg>
      `;

      const setLoading = (state) => {
        increaseBtn.disabled = state;
        decreaseBtn.disabled = state;
      };

      increaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        const newQty = parseInt(input.value) + 1;

        setLoading(true);
        if (await updateCart(key, newQty))
          await refreshCartDrawer((scrollToTop = true));
      });

      decreaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        let currentQty = parseInt(input.value);
        const maxQty = parseInt(input.max);
        console.log(currentQty, maxQty);
        // if (currentQty > maxQty) currentQty = maxQty + 1;
        // if (currentQty <= 1) return;
        setLoading(true);
        if (await updateCart(key, currentQty - 1))
          await refreshCartDrawer((scrollToTop = true));
      });

      removeBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        removeBtn.disabled = true;
        removeBtn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        removeBtn.style.borderBottom = "none";
        if (await updateCart(key, 0)) await refreshCartDrawer();
      });
    });
}

function bindQuantityControlsUpsell() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input-upsell");
      const increaseBtn = container.querySelector(
        '[data-action="increase-upsell"]'
      );
      const decreaseBtn = container.querySelector(
        '[data-action="decrease-upsell"]'
      );

      increaseBtn?.addEventListener("click", async () => {
        const newQty = parseInt(input.value) + 1;
        const maxQty = parseInt(input.max);
        if (newQty <= maxQty || maxQty < 0) {
          input.value = newQty;
          decreaseBtn.disabled = false;
        }
        if (newQty >= maxQty && maxQty > 0) {
          increaseBtn.disabled = true;
        }
        bindAddToCartButtons();
      });

      decreaseBtn?.addEventListener("click", async () => {
        const newQty = parseInt(input.value) - 1;

        if (newQty >= 1) {
          input.value = newQty;
          increaseBtn.disabled = false;
        }
        if (newQty <= 1) {
          decreaseBtn.disabled = true;
        }
        bindAddToCartButtons();
      });
    });
}

function bindAddToCartButtons() {
  document
    .querySelectorAll(".cart-drawer-item__add-to-cart-btn")
    .forEach((btn) => {
      const variantId = btn.dataset.variantId;
      const input = document.querySelector(".quantity-input-upsell");
      const quantity = input?.value ? parseInt(input?.value) : 1;
      // Avoid duplicate listeners
      btn.removeEventListener("click", btn._boundHandler);

      // Define and store the handler
      const handler = async () => {
        if (!variantId) return;

        // Store original content to restore later
        const originalHTML = btn.innerHTML;

        // Add loading state
        btn.disabled = true;
        btn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        btn.style.borderBottom = "none";

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          });

          const result = await res.json();

          if (res.ok) {
            // Show success tick with transition
            btn.innerHTML = `<span class="add-to-cart-tick">✓</span>`;
            btn.classList.add("success");

            // Wait a bit to show the tick, then refresh cart
            setTimeout(async () => {
              await refreshCartDrawer();
            }, 500);
          } else {
            // If failed, restore original button
            btn.disabled = false;
            btn.innerHTML = originalHTML;
            btn.style.borderBottom = "";
          }
        } catch (err) {
          console.log(err);
          // If error, restore original button
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.style.borderBottom = "";
        }
      };

      btn._boundHandler = handler;
      btn.addEventListener("click", handler);
    });
}
async function openCartDrawer(openCart = false) {
  document.getElementById("cartDrawer").classList.add("open");
  document.getElementById("cartDrawerOverlay").classList.add("show");
  document.body.style.overflow = "hidden";
  if (openCart) {
    await refreshCartDrawer((scrollToTop = true));
  }
}

function closeCartDrawer() {
  document.getElementById("cartDrawer").classList.remove("open");
  document.getElementById("cartDrawerOverlay").classList.remove("show");
  document.body.style.overflow = "";
}

document.addEventListener("DOMContentLoaded", () => {
  if (!cartDrawer || !overlay) {
    console.warn("Missing drawer or overlay in DOM");
    return;
  }

  // Open when icon clicked
  if (cartIcon) {
    cartIcon.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Close on overlay click
  overlay.addEventListener("click", () => {
    closeCartDrawer();
  });
  cartDrawerClose.addEventListener("click", () => {
    closeCartDrawer();
  });

  // Close on Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCartDrawer();
  });
});

function updateShippingProgressBar() {
  const shippingProgressContainer = document.getElementById(
    "cart-shipping-progress"
  );
  if (!shippingProgressContainer) return;

  const subtotal = parseFloat(shippingProgressContainer.dataset.cartSubtotal);
  const threshold = parseFloat(
    shippingProgressContainer.dataset.freeShippingThreshold
  );
  const preMessage = shippingProgressContainer.dataset.cartPreMessage;
  const postMessage = shippingProgressContainer.dataset.cartPostMessage;
  const remaining = Math.max(0, threshold - subtotal).toFixed(2);
  const percentage = Math.min(100, (subtotal / threshold) * 100).toFixed(1);

  const shippingMessage = document.getElementById("shippingRemaining");
  const pdpShippingMessage = document.getElementById("pdp-shipping-message");
  const progressBar = document.getElementById("progressBarFill");

  if (shippingMessage) {
    shippingMessage.textContent =
      remaining > 0
        ? preMessage?.replace("[remainingForGoalFormatted]", `$${remaining}`)
        : postMessage;
  }
  if (pdpShippingMessage) {
    pdpShippingMessage.textContent =
      remaining > 0 ? `Add $${remaining} more for free shipping!` : postMessage;
  }
  if (progressBar) progressBar.style.width = `${percentage}%`;
}
const cartDrawerContainer = document.querySelector(".cart-drawer-container");
const getLineItemKey = (el) =>
  el.closest("[data-line-item-key]")?.dataset.lineItemKey;
const updateCart = async (lineKey, quantity) => {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    return res.ok;
  } catch (error) {
    console.log(error);
  }
};

const updateCartNote = async (noteValue) => {
  try {
    cartNoteRequest = fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: noteValue }),
    });

    const res = await cartNoteRequest;
    cartNoteRequest = null;

    if (res.ok) {
      cartNoteLastSavedValue = noteValue;
      return true;
    }

    return false;
  } catch (error) {
    cartNoteRequest = null;
    console.log(error);
    return false;
  }
};

function bindCartNote() {
  const noteField = document.getElementById("CartNoteDrawer");
  const checkoutBtn = document.querySelector(".cart-drawer-checkout-btn");

  if (!noteField) return;

  cartNoteLastSavedValue = noteField.value;

  const queueSave = () => {
    const value = noteField.value;

    clearTimeout(cartNoteSaveTimer);
    cartNoteSaveTimer = setTimeout(async () => {
      if (value !== cartNoteLastSavedValue) {
        await updateCartNote(value);
      }
    }, 400);
  };

  noteField.addEventListener("input", queueSave);

  noteField.addEventListener("change", async () => {
    const value = noteField.value;
    clearTimeout(cartNoteSaveTimer);

    if (value !== cartNoteLastSavedValue) {
      await updateCartNote(value);
    }
  });

  noteField.addEventListener("blur", async () => {
    const value = noteField.value;
    clearTimeout(cartNoteSaveTimer);

    if (value !== cartNoteLastSavedValue) {
      await updateCartNote(value);
    }
  });

  // Ensure save before checkout redirect
  checkoutBtn?.addEventListener("click", async (e) => {
    const value = noteField.value;

    if (value !== cartNoteLastSavedValue) {
      e.preventDefault();
      const saved = await updateCartNote(value);
      if (saved) {
        window.location.href = checkoutBtn.href;
      }
    }
  });
}

const restoreCartScroll = (cartScrollTop) => {
  if (cartDrawerContainer) {
    cartDrawerContainer.scrollTop = cartScrollTop;
  }
};

const refreshCartDrawer = async (scrollToTop) => {
  const cartScrollTop = document.getElementById("cartDrawer").scrollTop;
  const res = await fetch(
    window.location.pathname + "?sections=new-cart-drawer"
  );
  const data = await res.json();
  if (data["new-cart-drawer"] && cartDrawerContainer) {
    cartDrawerContainer.innerHTML = data["new-cart-drawer"];
    document.getElementById("cartDrawer")?.classList.add("open");
    document.getElementById("cartDrawerOverlay")?.classList.add("show");
    document.body.style.overflow = "hidden";
    bindQuantityControls();
    updateShippingProgressBar();
    bindAddToCartButtons();
    bindQuantityControlsUpsell();

    bindCartNote();

    if (scrollToTop) {
      restoreCartScroll(cartScrollTop);
    }
    const cartCount = document.getElementById("cart-drawer-item-count")?.dataset
      ?.cartCount;
    const bubble = document.querySelector(".cart-link__bubble");
    if (bubble && cartCount) {
      //   bubble.innerText = cartCount;
      bubble.classList.toggle("cart-link__bubble--visible", cartCount > 0);
    }
    if (Number(cartCount) <= 0) {
      const pdpShippingMessage = document.getElementById(
        "pdp-shipping-message"
      );
      if (pdpShippingMessage) {
        pdpShippingMessage.textContent = "";
      }
    }
  }
};

// Initial bindings
bindQuantityControls();
updateShippingProgressBar();
bindAddToCartButtons();
bindQuantityControlsUpsell();

bindCartNote();